module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: ['hamburger', 'hamburger--spin', _vm.theme, _vm.state, _vm.closebtn],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emitEvent(_vm.theme, _vm.state)
      }
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamburger-box"
  }, [_c('span', {
    staticClass: "hamburger-inner"
  }, [_c('span', {
    staticClass: "hamburger-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "hamburger-down"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44272e26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonMore.vue
// module id = 114
// module chunks = 1